function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 5.12988L18 8.55845V13.2179H16V9.87725L10 7.30582L4 9.87725V13.2179H2V8.55845L10 5.12988Z",
  fill: "#E7E7E7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 10.2178H13.5V13.2178H11.5V12.2178H8.5V13.2178H6.5V10.2178Z",
  fill: "#E7E7E7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 4.39335V13.2178H16V4.21777H17C16 4.21777 16 4.21679 16 4.21581L16 4.21381L16 4.20972L16.0001 4.20118L16.0006 4.18266C16.001 4.16969 16.0017 4.15545 16.0027 4.14002C16.0048 4.1092 16.0082 4.07341 16.014 4.03338C16.0254 3.9535 16.0459 3.85529 16.0826 3.7453C16.1571 3.52184 16.2957 3.25783 16.5429 3.01067C17.0466 2.50699 17.8459 2.21777 19 2.21777C20.1541 2.21777 20.9534 2.50699 21.4571 3.01067C21.7043 3.25783 21.8429 3.52184 21.9174 3.7453C21.9541 3.85529 21.9746 3.9535 21.986 4.03338C21.9918 4.07341 21.9952 4.1092 21.9973 4.14002C21.9983 4.15545 21.999 4.16969 21.9994 4.18266L21.9999 4.20118L22 4.20972L22 4.21381L22 4.21581C22 4.21679 22 4.21777 21 4.21777H22V13.2178H20V4.39335C19.9688 4.37429 19.9181 4.34872 19.84 4.32271C19.6836 4.27058 19.4197 4.21777 19 4.21777C18.5803 4.21777 18.3164 4.27058 18.16 4.32271C18.0819 4.34872 18.0312 4.37429 18 4.39335Z",
  fill: "#E7E7E7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 16.2178H2V14.2178H22V16.2178Z",
  fill: "#E7E7E7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 19.2178H2V17.2178H22V19.2178Z",
  fill: "#E7E7E7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 22.2178H2V20.2178H22V22.2178Z",
  fill: "#E7E7E7"
});

function SvgFieldActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldActivities);
export default __webpack_public_path__ + "static/media/FieldActivities.67c84654.svg";
export { ForwardRef as ReactComponent };